import styled from 'styled-components'

import { CloseIcon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Gear2Icon } from '@root/shared/ui-kit'

export const TradeSettingsHeader: React.FC<{
  onClose?: () => void
}> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Header>
        <Gear2Icon size={16} />
        <span>{t('trade_settings.preset-settings')}</span>
      </Header>
      <CloseButton onClick={onClose}>
        <CloseIcon size={20} />
      </CloseButton>
    </Root>
  )
}

const Root = styled.div`
  border-bottom: 1px solid var(--background-3);
  color: var(--text-12);

  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  justify-content: center;

  gap: 6px;

  padding-inline: 10px;
  padding-block: 15px;
  font-size: 14px;

  font-weight: 600;
  line-height: 20px;
`

const Header = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 6px;
  justify-content: start;
  align-items: center;
`

const CloseButton = styled.div`
  cursor: pointer;
  display: grid;
  align-items: center;
  justify-content: center;

  color: var(--text-8);
  transition: color 0.15s ease-in-out;

  &:hover {
    color: var(--text-10);
  }
`
